export default __webpack_public_path__ + "media/images/audio-placeholder-77fdb7f1e48f9af8b5a5f360e05cbee6.png";